const toNumberOrNull = (value) =>
  typeof value === 'number' && !Number.isNaN(value) ? value : null;

export const normalizeMatchingInternalProduct = (product) => {
  const stockQuantity = toNumberOrNull(
    product?.stockQuantity ?? product?.stock?.quantity
  );
  const stockQuantityEnca = toNumberOrNull(
    product?.stockQuantityEnca ?? product?.stock?.quantity_enca
  );
  const stockQuantityEnco = toNumberOrNull(
    product?.stockQuantityEnco ?? product?.stock?.quantity_enco
  );

  return {
    ...product,
    reference: product?.reference || '',
    title: product?.title || null,
    color: product?.color || null,
    packaging: product?.packaging || null,
    stockQuantity,
    stockQuantityEnca,
    stockQuantityEnco,
    stock: {
      quantity: stockQuantity,
      quantity_enca: stockQuantityEnca,
      quantity_enco: stockQuantityEnco,
      ...(product?.stock || {}),
    },
  };
};

export const normalizeMatchingInternalProducts = (products) =>
  Array.isArray(products) ? products.map(normalizeMatchingInternalProduct) : [];
